/**
 * Lectura de filtros desde la URL, comun a las tablas del backoffice
 * (productos, pedidos). Cada valor que no se entiende se descarta: un enlace
 * viejo o escrito a mano muestra la tabla sin ese filtro, no un error.
 */

export function booleano(valor: string | null): boolean | undefined {
  if (valor === 'true') return true;
  if (valor === 'false') return false;
  return undefined;
}

/** Entero no negativo. */
export function cantidad(valor: string | null): number | undefined {
  if (valor === null || valor.trim() === '') return undefined;
  const numero = Number(valor);
  return Number.isInteger(numero) && numero >= 0 ? numero : undefined;
}

/** Parametro repetido (`?marca=a&marca=b`), sin vacios ni repetidos. */
export function lista(parametros: URLSearchParams, clave: string): string[] | undefined {
  const valores = Array.from(new Set(parametros.getAll(clave).filter((valor) => valor.length > 0)));
  return valores.length > 0 ? valores : undefined;
}

export function texto(valor: string | null): string | undefined {
  const limpio = valor?.trim() ?? '';
  return limpio.length > 0 ? limpio : undefined;
}

/** El valor si es una de las opciones permitidas. */
export function unoDe<T extends string>(valor: string | null, opciones: readonly T[]): T | undefined {
  return opciones.find((opcion) => opcion === valor);
}

/** Sin claves con `undefined`: el objeto sale limpio para compararlo o copiarlo. */
export function compactar<T extends object>(filtros: T): T {
  return Object.fromEntries(
    Object.entries(filtros).filter(([, valor]) => valor !== undefined),
  ) as T;
}

/** Un filtro puesto, como chip: su texto y como quedan los filtros sin el. */
export interface FiltroActivo<F> {
  clave: string;
  texto: string;
  sinEste: F;
}
